// Minimal cart item shape needed for cart validation.
interface ValidatableCartItem {
  checked?: boolean;
  quantity: number;
  sku?: {
    moq?: number;
  };
}

// Minimal cart shape needed for cart validation.
interface ValidatableCart {
  moq: number;
  items: ValidatableCartItem[];
}

class CartValidatorService {
  canCheckout(carts: ValidatableCart[]): boolean {
    const selectedCarts = carts.filter((cart) => this.isSelectedCart(cart));

    return selectedCarts.length > 0 && this.validateCarts(selectedCarts);
  }

  validateCarts(carts: ValidatableCart[]): boolean {
    return carts
      .filter((cart) => this.isSelectedCart(cart))
      .every((cart) => this.validateCart(cart));
  }

  validateCart(cart: ValidatableCart): boolean {
    const selectedItems = this.getSelectedItems(cart);

    return (
      this.selectedItemsMeetCartMOQ(cart, selectedItems) &&
      this.selectedItemsMeetItemMOQ(selectedItems)
    );
  }

  private isSelectedCart(cart: ValidatableCart): boolean {
    return cart.items.some((item) => item.checked);
  }

  private getSelectedItems(cart: ValidatableCart): ValidatableCartItem[] {
    return cart.items.filter((item) => item.checked);
  }

  private selectedItemsMeetCartMOQ(
    cart: ValidatableCart,
    selectedItems: ValidatableCartItem[],
  ): boolean {
    const cartMinimumOrderQuantity = cart.moq;
    const totalSelectedQuantity = selectedItems.reduce(
      (selectedQuantity, item) => selectedQuantity + item.quantity,
      0,
    );

    return cartMinimumOrderQuantity === 0 || totalSelectedQuantity >= cartMinimumOrderQuantity;
  }

  private selectedItemsMeetItemMOQ(selectedItems: ValidatableCartItem[]): boolean {
    return selectedItems.every((item) => this.selectedItemMeetsItemMOQ(item));
  }

  private selectedItemMeetsItemMOQ(item: ValidatableCartItem): boolean {
    const itemMinimumOrderQuantity = item.sku?.moq ?? 0;

    return itemMinimumOrderQuantity === 0 || item.quantity >= itemMinimumOrderQuantity;
  }
}

export default CartValidatorService;
